import * as React from 'react';
import type { SVGProps } from 'react';

const SvgUt = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200" {...props}>
    <path d="M937.2 332.4c0-1.2-1.2-1.2 0 0l-268.8 3.602-1.2-180s0-1.2-1.198-1.2l-313.2-2.398-84-2.398s-1.2 0-1.2 1.199l-24 898.8v1.199h711.599v-1.2z" />
  </svg>
);
export default SvgUt;
